import { Checkbox } from '@fluentui/react-components'
import React from 'react'
import { Control, Controller } from 'react-hook-form'

type PartnerCheckboxProps = {
   name: any
   control: Control<any>
   label: string
   labelPosition?: 'before' | 'after'
   disabled?: boolean
   uncheckWarning?: () => Promise<boolean>
}
export const PartnerCheckbox = ({ name, control, label, labelPosition, disabled, uncheckWarning }: PartnerCheckboxProps) => {
   return (
      <Controller
         control={control}
         name={name}
         render={({ field: { value, onChange }, formState: { disabled: formDisabled } }) => (
            <Checkbox
               labelPosition={labelPosition ?? 'after'}
               size="large"
               label={label}
               checked={value}
               disabled={(disabled || formDisabled) ?? false}
               onChange={async (_, checkbox) => {
                  if (!checkbox.checked && uncheckWarning) {
                     const confirmed = await uncheckWarning()
                     if (!confirmed) return
                  }
                  onChange(checkbox.checked)
               }}
            />
         )}
      />
   )
}
